import React from 'react';

const TechBadge = ({ name, logoUrl, url }) => {
  // Technology-specific color mappings with transparent backgrounds
  const techColors = {
    'React': {
      light: 'bg-cyan-50 text-cyan-700 border-cyan-200 hover:bg-cyan-500/20 hover:text-cyan-400 hover:border-cyan-500',
      dark: 'dark:hover:bg-cyan-600/20 dark:hover:text-cyan-400 dark:hover:border-cyan-500',
    },
    'Next.js': {
      light: 'bg-slate-50 text-slate-700 border-slate-200 hover:bg-slate-600/20 hover:text-slate-300 hover:border-slate-500',
      dark: 'dark:hover:bg-slate-700/20 dark:hover:text-slate-300 dark:hover:border-slate-500',
    },
    'NestJS': {
      light: 'bg-red-50 text-red-700 border-red-200 hover:bg-red-500/20 hover:text-red-400 hover:border-red-500',
      dark: 'dark:hover:bg-red-600/20 dark:hover:text-red-400 dark:hover:border-red-500',
    },
    'PostgreSQL': {
      light: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-500/20 hover:text-blue-400 hover:border-blue-500',
      dark: 'dark:hover:bg-blue-600/20 dark:hover:text-blue-400 dark:hover:border-blue-500',
    },
    'TypeScript': {
      light: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-500/20 hover:text-blue-400 hover:border-blue-500',
      dark: 'dark:hover:bg-blue-600/20 dark:hover:text-blue-400 dark:hover:border-blue-500',
    },
    'TailwindCSS': {
      light: 'bg-teal-50 text-teal-700 border-teal-200 hover:bg-teal-500/20 hover:text-teal-400 hover:border-teal-500',
      dark: 'dark:hover:bg-teal-500/20 dark:hover:text-teal-400 dark:hover:border-teal-500',
    },

    'Jungle Bike': {
      light: 'bg-green-50 text-green-700 border-green-200 hover:bg-green-500/20 hover:text-green-400 hover:border-green-500',
      dark: 'dark:hover:bg-green-600/20 dark:hover:text-green-400 dark:hover:border-green-500',
    },
    'Partech Partners': {
      light: 'bg-red-50 text-red-700 border-red-200 hover:bg-red-500/20 hover:text-red-400 hover:border-red-500',
      dark: 'dark:hover:bg-red-600/20 dark:hover:text-red-400 dark:hover:border-red-500',
    },
    'Link Up': {
      light: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-500/20 hover:text-blue-400 hover:border-blue-500',
      dark: 'dark:hover:bg-blue-600/20 dark:hover:text-blue-400 dark:hover:border-blue-500',
    },
  };

  // Get colors for the specific technology, or use default
  const colors = techColors[name] || {
    light: 'bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-500/20 hover:text-gray-300 hover:border-gray-500',
    dark: 'dark:hover:bg-gray-600/20 dark:hover:text-gray-300 dark:hover:border-gray-500',
  };

  return (
    <a
      href={url || '#'}
      target="_blank"
      rel="noopener noreferrer"
      className={`
        inline-flex items-center gap-2 px-3 py-1.5 rounded-md
        transition-all hover:scale-105 border
        ${colors.light}
        dark:bg-black/20 dark:text-[rgb(162,162,162)] dark:border-[rgb(41,41,41)]
        ${colors.dark}
      `}
    >
      {logoUrl && (
        <img
          src={logoUrl}
          alt={name}
          className="w-4 h-4 object-contain"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      )}
      <span className="text-sm font-medium">{name}</span>
    </a>
  );
};

export default TechBadge;